/* eslint-disable import/no-anonymous-default-export */
import React from "react";

/* batiment */

/* projet tradex */

import tradexImg1 from "../../assets/imgs/img-projet/batiment/img-tradex/34.jpg";
import tradexImg2 from "../../assets/imgs/img-projet/batiment/img-tradex/23.jpg";

/* projet CRID */
import immeubleCrid from "../../assets/imgs/img-projet/batiment/img-crid/crid.jpg";
import plaqueCrid from "../../assets/imgs/img-projet/batiment/img-crid/26.jpg";

/* projet batiment administratif kribi */
import baKribi from "../../assets/imgs/img-projet/batiment/img-kribi/bapk.jpg";

/* projet d'habitation r+ 1*/
import planR1 from "../../assets/imgs/img-projet/batiment/img-r+1/14.jpg";
import plan2R1 from "../../assets/imgs/img-projet/batiment/img-r+1/18.jpg";
import batiment1R1 from "../../assets/imgs/img-projet/batiment/img-r+1/16.jpg";
import batiment2R1 from "../../assets/imgs/img-projet/batiment/img-r+1/11.jpg";

/* construction d'un batiment R2 */
import planR2 from "../../assets/imgs/img-projet/batiment/img-rdc+2/9.jpg";
import batimentR2 from "../../assets/imgs/img-projet/batiment/img-rdc+2/4.jpg";

/* btc */
import btc from "../../assets/imgs/img-projet/batiment/btc/N6.jpg"
import btc2 from "../../assets/imgs/img-projet/batiment/btc/N7.jpg"

/* hydrolique */

/* filtre-pak */
import imgFiltre from "../../assets/imgs/img-projet/hydrolique/img-filtre-pak/img-filtre1.jpg";

/* reservoir-pak */

import imgPak1 from "../../assets/imgs/img-projet/hydrolique/img-reservoir-pak/pak-1.jpg";
import imgPak2 from "../../assets/imgs/img-projet/hydrolique/img-reservoir-pak/pak-2.jpg";

/* wenchi-water */

import wenchi1 from "../../assets/imgs/img-projet/hydrolique/img-wnchi-water/img1.jpg";
import wenchi2 from "../../assets/imgs/img-projet/hydrolique/img-wnchi-water/img2.jpg";

/* le dessableur */
import dessableur1 from "../../assets/imgs/img-projet/hydrolique/img-dessableur/1.jpg";

/* bloc process ghana */
import bpw1 from "../../assets/imgs/img-projet/hydrolique/bloc-process-wenchi/N2.jpg";
import bpw2 from "../../assets/imgs/img-projet/hydrolique/bloc-process-wenchi/N2+.jpg";
import bpw3 from "../../assets/imgs/img-projet/hydrolique/bloc-process-wenchi/N2++.jpg";

/* bloc process kribi */
import bpk from "../../assets/imgs/img-projet/hydrolique/bloc-process-kribi/N5.jpg";

/* construction du contact tank */
import cct from "../../assets/imgs/img-projet/hydrolique/img-contact-tank/N3.jpg";

import cfao from "../../assets/imgs/img-projet/batiment/btc/cfao.jpg";
import cfao1 from "../../assets/imgs/img-projet/batiment/btc/cfao1.jpg";
import unesco from "../../assets/imgs/img-projet/batiment/btc/unesco.jpeg";
import unesco2 from "../../assets/imgs/img-projet/batiment/btc/unesco2.jpeg";
import playce from "../../assets/imgs/img-projet/batiment/btc/playce.jpg";
import playce1 from "../../assets/imgs/img-projet/batiment/btc/playce1.jpg";
import playce2 from "../../assets/imgs/img-projet/batiment/btc/playce2.jpg";
import playce3 from "../../assets/imgs/img-projet/batiment/btc/playce3.jpg";
import metal from "../../assets/imgs/img-projet/batiment/btc/metal.jpg";
import metal2 from "../../assets/imgs/img-projet/batiment/btc/metal2.jpg";

// images nouveaux projets
import local_technique_PlaYce1 from "../../assets/imgs/img-projet/batiment/img-local-technique/local_technique_1.jpg";
import local_technique_PlaYce2 from "../../assets/imgs/img-projet/batiment/img-local-technique/local_technique_2.jpg";
import local_technique_PlaYce3 from "../../assets/imgs/img-projet/batiment/img-local-technique/local_technique_3.jpg";
import garde_corps_unesco1 from "../../assets/imgs/img-projet/batiment/img-unesco/garde_corps_unesco_1.jpg";
import garde_corps_unesco2 from "../../assets/imgs/img-projet/batiment/img-unesco/garde_corps_unesco_2.jpg";
import garde_corps_unesco3 from "../../assets/imgs/img-projet/batiment/img-unesco/garde_corps_unesco_3.jpeg";
import garde_corps_unesco4 from "../../assets/imgs/img-projet/batiment/img-unesco/garde_corps_unesco_4.jpeg";
import bache_eau_PlaYce1 from "../../assets/imgs/img-projet/infrastructure/img-bache-eau/reservoir_eau_1.jpg";
import bache_eau_PlaYce2 from "../../assets/imgs/img-projet/infrastructure/img-bache-eau/reservoir_eau_2.jpg";
import bache_eau_PlaYce3 from "../../assets/imgs/img-projet/infrastructure/img-bache-eau/reservoir_eau_3.jpg";
import bache_eau_PlaYce4 from "../../assets/imgs/img-projet/infrastructure/img-bache-eau/reservoir_eau_4.jpg";
import regard_parking_PlaYce1 from "../../assets/imgs/img-projet/infrastructure/img-regard/regard_1.jpg";
import regard_parking_PlaYce2 from "../../assets/imgs/img-projet/infrastructure/img-regard/regard_2.jpg";
import regard_parking_PlaYce3 from "../../assets/imgs/img-projet/infrastructure/img-regard/regard_3.jpg";


export default {
  tradexImg1,
  tradexImg2,
  immeubleCrid,
  plaqueCrid,
  baKribi,
  plan2R1,
  planR1,
  batiment1R1,
  batiment2R1,
  planR2,
  batimentR2,
  btc,
  btc2,
  dessableur1,
  imgFiltre ,
  imgPak1 ,
  imgPak2 ,
  wenchi1 ,
  wenchi2 ,
  bpw1,
  bpw2,
  bpw3,
  bpk,
  cct,
  cfao,
  cfao1,
  playce,
  playce2,
  playce1,
  playce3,
  unesco,
  unesco2,
  metal,
  metal2,
  local_technique_PlaYce1,
  local_technique_PlaYce2,
  local_technique_PlaYce3,
  garde_corps_unesco1,
  garde_corps_unesco2,
  garde_corps_unesco3,
  garde_corps_unesco4,
  bache_eau_PlaYce1,
  bache_eau_PlaYce2,
  bache_eau_PlaYce3,
  bache_eau_PlaYce4,
  regard_parking_PlaYce1,
  regard_parking_PlaYce2,
  regard_parking_PlaYce3,
};
